"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SignalrService = void 0;
var _signalr = require("@microsoft/signalr");
var _types = require("../com/types");
var _errorReporter = require("../../../utils/errorReporter");
var _CommandType = require("../../dovahzul/CommandType");
var _IdentifierRequest = require("../../dovahzul/requests/IdentifierRequest");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SignalrService = exports.SignalrService = /*#__PURE__*/function () {
  function SignalrService() {
    var _this = this;
    _classCallCheck(this, SignalrService);
    _defineProperty(this, "_connection", void 0);
    _defineProperty(this, "_store", void 0);
    /** Reconnect attempts after having had a success full connection. */
    _defineProperty(this, "_reconnectAttempts", 0);
    /** max attempt before it sets it self as dead and will stop retrying, unrecoverable */
    _defineProperty(this, "MAX_RECONNECT_ATTEMPTS", 5);
    /** amount of attempts to start/connect. */
    _defineProperty(this, "_connectAttempts", 0);
    _defineProperty(this, "MAX_CONNECT_ATTEMPTS", 3);
    /** if currently connects */
    _defineProperty(this, "_connected", void 0);
    /** qeue for commands yet to be send, items sent before we are connected or during a disconnect are inserted here. */
    _defineProperty(this, "_pending", []);
    _defineProperty(this, "_retry", []);
    /** If client has been disconnected on purpose, kill the connection to the server. Due to error or shutdown */
    _defineProperty(this, "_killed", void 0);
    _defineProperty(this, "send", function (command) {
      var p;
      if (!_this._connected) {
        _this._pending.push(command);
        return;
      }
      switch (command.type) {
        case _CommandType.CommandType.StartGameRequest:
          {
            p = _this._connection.send("StartGame", command);
            break;
          }
        case _CommandType.CommandType.CollectRequest:
          {
            p = _this._connection.send("Collect", command);
            break;
          }
        case _CommandType.CommandType.SpinRequest:
          {
            p = _this._connection.send("Spin", command);
            break;
          }
        case _CommandType.CommandType.BlitzStopRequest:
          {
            p = _this._connection.send("BlitzStop", command);
            break;
          }
        case _CommandType.CommandType.BlitzStartRequest:
          {
            p = _this._connection.send("BlitzStart", command);
            break;
          }
        case _CommandType.CommandType.ExitRequest:
          {
            p = _this._connection.send("Exit", command);
            break;
          }
        case _CommandType.CommandType.PromotionStartRequest:
          {
            p = _this._connection.send("StartPromotion", command);
            break;
          }
        case _CommandType.CommandType.KeepAliveRequest:
          {
            p = _this._connection.send("KeepAlive", command);
            break;
          }
        case _CommandType.CommandType.BalanceRequest:
          {
            p = _this._connection.send("Balance", command);
            break;
          }
        case _CommandType.CommandType.AckRequest:
          {
            p = _this._connection.send("Ack", command);
            break;
          }
        case _CommandType.CommandType.ContinueRequest:
          {
            p = _this._connection.send("Continue", command);
            break;
          }
        case _CommandType.CommandType.StatEventRequest:
          {
            p = _this._connection.send("Stat", command);
            break;
          }
        case _CommandType.CommandType.ReplayRequest:
          {
            p = _this._connection.send("ReplayRound", command);
            break;
          }
        case _CommandType.CommandType.PlayerActionRequest:
          {
            p = _this._connection.send("PlayerAction", command);
            break;
          }
        default:
          // Custom command support. does not work due to inheritenice issue on servierside
          if (command.type >= 5000) {
            p = _this._connection.send("Command", command);
          } else {
            console.warn("Unhandled command sent.");
          }
          // console.warn("Unhandled command sent.");

          return;
      }
      // console.log(command.type)
      p["catch"](function () {
        console.warn(command.type + " failed");
        _this._retry.push(command);
      });
    });
  }
  return _createClass(SignalrService, [{
    key: "connect",
    value: function connect(store) {
      var _this2 = this;
      var state = store.getState();
      this._store = store;
      if (state.config.msgP) {
        this._connection = new _signalr.HubConnectionBuilder().withUrl(state.config.serverUrl)
        //  .configureLogging(LogLevel.Trace)
        //  .withHubProtocol(new signalRMsgPack.MessagePackHubProtocol())
        .build();
      } else {
        this._connection = new _signalr.HubConnectionBuilder().withUrl(state.config.serverUrl, {
          skipNegotiation: true,
          transport: _signalr.HttpTransportType.WebSockets
        }).configureLogging(_signalr.LogLevel.Warning).build();
      }
      // DEBUG PURPOSE
      window['con'] = this._connection;
      this.start();
      //Reconnect Handling
      this._connection.onclose(function () {
        if (_this2._killed) {
          console.warn("Unrecoverabe error, will not reconnect to server.");
        } else if (!store.getState().game.sessionExpired) {
          console.warn("onclose, reconnecting");
          _this2.reconnect();
        } else {
          console.warn("Session Expired, need to restart game with new token.");
        }
      });
      this._connection.on("action", function (a) {
        store.dispatch({
          type: _types.COMMAND_RECEIVED,
          payload: a
        });
      });
    }
  }, {
    key: "start",
    value: function start() {
      var _this3 = this;
      this._connectAttempts++;
      this._connection.start().then(function () {
        _this3._reconnectAttempts = 0;
        _this3._connected = true;
        _this3._store.dispatch({
          type: _types.CONNECTED
        });
        for (var index = 0; index < _this3._pending.length; index++) {
          _this3.send(_this3._pending[index]);
        }
      })["catch"](function (f) {
        if (_this3._connectAttempts < 3) {
          setTimeout(function () {
            _this3.start();
          }, _this3._connectAttempts * 3000); // 3 sec for first, 6 sec after that total of 9 sec before error and we are screwed.
        } else {
          // Note, websocket does not allow to read the HTTP status code here, so we cant read it. its part of the Websocket Specs.
          _this3._store.dispatch({
            type: _types.CONNECTION_FAILED
          });
          (0, _errorReporter.reportError)("Game Client Failed to Connect to server: " + f.message);
        }
      });
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      var _this4 = this;
      setTimeout(function () {
        if (_this4._reconnectAttempts > _this4.MAX_RECONNECT_ATTEMPTS - 1) {
          console.error("Max Reconnect attempts reached. Disconnected.");
          _this4._store.dispatch({
            type: _types.DISCONNECTED
          });
          return;
        }
        console.warn("Reconnecting to Server.");
        _this4._store.dispatch({
          type: _types.RECONNECTING
        });
        _this4._reconnectAttempts++;
        _this4._connection.start().then(function () {
          var state = _this4._store.getState();
          // note that we get a new signalr connectionId here, but not a dragon connectionId.
          // after a reconnect these two will differ.
          // console.log("Reconnect on connectionId " + state.config.connectionId);

          _this4._connection.send("reconnect", new _IdentifierRequest.IdentifierRequest(state.config.playerId, state.config.connectionId, 0));
          _this4._store.dispatch({
            type: _types.RECONNECTED
          });
          console.warn("Reconnected");
          _this4._reconnectAttempts = 0;

          //retry commands that failed.
          while (_this4._retry.length > 0) {
            console.log("Retry command");
            _this4.send(_this4._retry.shift());
          }
        })["catch"](function () {
          _this4.reconnect();
        });
      }, this._reconnectAttempts * 1500);
    }
    /**
     * Call for app decided disconnect, when game client thinks the connection should no longer exist. its in an error state or shutdown or timedout.
     * This is done to attempt to reduce "idle" connections towards the server.
     */
  }, {
    key: "disconnect",
    value: function disconnect() {
      this._killed = true;
      this._connection.stop();
    }
  }]);
}();
//# sourceMappingURL=signalrService.js.map